module.exports = __webpack_public_path__ + "img/criticaledition_active.5d499320.svg";